module.exports = __webpack_public_path__ + "static/chat-48e9d961c98622fcefe6bcff43e3dd66.png";